import { observer } from "mobx-react-lite";
import { FC } from "react";

interface AdminPageProps {}

export const AdminPage: FC<AdminPageProps> = observer(() => {
  return <div>AdminPage</div>;
});
